export default class Modals {
  constructor(modalBtn) {
    this.$ = modalBtn;
    this.wrapperID = this.$.dataset.modal;
    this.wrapper = document.getElementById(this.wrapperID);
    this.closeButtons = Array.from(this.wrapper.querySelectorAll('.js-modal-close'));
    this.hiddenClass = 'm-hidden';
    this.noScrollClass = 'm-noscroll';
    this.initialize();
    this.bind();
  }

  initialize() {
    if(!this.wrapper.classList.contains(this.hiddenClass)){
      this.bodyScrollStop();
    }
  }

  bind() {
    this.$.addEventListener('click', this.modalOpen.bind(this));
    this.closeButtons.forEach(closeButton => {
      closeButton.addEventListener('click', this.modalClose.bind(this));
    })
  }

  modalOpen(){
    this.wrapper.classList.remove(this.hiddenClass);
    this.bodyScrollStop();
  }
  modalClose(){
    this.wrapper.classList.add(this.hiddenClass);
    this.bodyScrollAuto();
  }

  bodyScrollStop(){
    document.body.style.top = `-${window.scrollY}px`;
    document.body.classList.add(this.noScrollClass);
  }
  bodyScrollAuto(){
    const top = document.body.style.top;
    document.body.classList.remove(this.noScrollClass);
    window.scrollTo(0, parseInt(top || '0') * -1);
    document.body.style.top = '';
  }

}

